import { dateShortMonth } from "@circle-react/helpers/dateTimeHelpers/getLocalizedDate";
import type { CircleAiDailyBrief } from "@circle-react/types/CircleAiDailyBrief";

import { t } from "@/i18n-js/instance";

// Mirrors the daily brief conversation title (SeedConversation#conversation_title):
// the day number when present, otherwise just the date.
export const formatDailyBriefTitle = (
  brief: Pick<CircleAiDailyBrief, "brief_date" | "day_number">,
) => {
  const date = dateShortMonth(brief.brief_date, "UTC");
  return brief.day_number != null
    ? t("circle_ai_home.daily_brief.header_title", {
        day_number: brief.day_number,
        date,
      })
    : date;
};
